// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as VideoTextPromoBlock__Settings$PrezzeeRibbon from "./VideoTextPromoBlock__Settings.bs.js";

var imageWrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.flexShrink(1),
      BsCssJs$PrezzeeRibbon.flexGrow(1),
      BsCssJs$PrezzeeRibbon.flexBasis("auto"),
      BsCssJs$PrezzeeRibbon.overflowY("hidden"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, [
            BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(VideoTextPromoBlock__Settings$PrezzeeRibbon.desktopImageVideoOffsetPx)),
            BsCssJs$PrezzeeRibbon.position("relative")
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [
            BsCssJs$PrezzeeRibbon.flexShrink(0),
            BsCssJs$PrezzeeRibbon.flexGrow(0),
            BsCssJs$PrezzeeRibbon.unsafe("maxWidth", "calc(100% - 242px)"),
            BsCssJs$PrezzeeRibbon.display("flex"),
            BsCssJs$PrezzeeRibbon.justifyContent("flexEnd")
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [
            BsCssJs$PrezzeeRibbon.flexShrink(1),
            BsCssJs$PrezzeeRibbon.flexGrow(1),
            BsCssJs$PrezzeeRibbon.maxWidth("none"),
            BsCssJs$PrezzeeRibbon.alignItems("center"),
            BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.px(VideoTextPromoBlock__Settings$PrezzeeRibbon.videoBottomOffsetMobile))
          ])
    ]);

var cardCollection = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, [
            BsCssJs$PrezzeeRibbon.position("absolute"),
            BsCssJs$PrezzeeRibbon.right(BsCssJs$PrezzeeRibbon.px(VideoTextPromoBlock__Settings$PrezzeeRibbon.desktopImageVideoOffsetPx)),
            BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.pct(50)),
            BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.translateY(BsCssJs$PrezzeeRibbon.pct(-50)))
          ])]);

var cardCollectionItem = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrDesktop, [BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(366))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tablet, [BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.px(230))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [
            BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.pct(100))
          ]),
      BsCssJs$PrezzeeRibbon.children([
            BsCssJs$PrezzeeRibbon.display("block"),
            BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, [
                  BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.pct(100)),
                  BsCssJs$PrezzeeRibbon.height("auto"),
                  BsCssJs$PrezzeeRibbon.position("absolute"),
                  BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.pct(50)),
                  BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.pct(50)),
                  BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.translate(BsCssJs$PrezzeeRibbon.pct(-50), BsCssJs$PrezzeeRibbon.pct(-50)))
                ]),
            BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100))])
          ])
    ]);

var Styles = {
  imageWrapper: imageWrapper,
  cardCollection: cardCollection,
  cardCollectionItem: cardCollectionItem
};

function VideoTextPromoBlock__SideImage(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: props.children,
                                className: cardCollectionItem
                              }),
                          className: cardCollection
                        }),
                    className: Classnames([
                          imageWrapper,
                          className$1
                        ])
                  })
            });
}

var Settings;

var make = VideoTextPromoBlock__SideImage;

export {
  Settings ,
  Styles ,
  make ,
}
/* imageWrapper Not a pure module */
